import { render, staticRenderFns } from "./batchChange.vue?vue&type=template&id=1b724ce6&scoped=true"
import script from "./batchChange.vue?vue&type=script&lang=js"
export * from "./batchChange.vue?vue&type=script&lang=js"
import style0 from "./batchChange.vue?vue&type=style&index=0&id=1b724ce6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b724ce6",
  null
  
)

export default component.exports